import { Component } from '@theme/component';
import { ThemeEvents } from '@theme/events';

/**
 * A custom element that manages the request quote form and updates it based on variant changes.
 */
export default class RequestQuoteForm extends Component {
  connectedCallback() {
    super.connectedCallback();
    
    // Listen for variant updates
    const closestSection = this.closest('.shopify-section');
    closestSection?.addEventListener(ThemeEvents.variantUpdate, this.#handleVariantUpdate);
  }

  /**
   * Handles variant update events and updates the form fields.
   * @param {CustomEvent} event - The variant update event.
   */
  #handleVariantUpdate = (event) => {
    const variant = event.detail.resource;
    
    if (!variant) return;
    
    // Update the product field with new variant title
    const productField = this.querySelector('[name="contact[product]"]');
    if (productField instanceof HTMLInputElement) {
      const productTitle = this.dataset.productTitle || 'Product';
      // For products without variants, just use the product title
      if (variant.title && variant.title) {
        productField.value = `${productTitle} - ${variant.title}`;
      } else {
        productField.value = productTitle;
      }
    }
    
    // Update the variant ID field
    const variantIdField = this.querySelector('[name="contact[product_id]"]');
    if (variantIdField instanceof HTMLInputElement) {
      variantIdField.value = variant.id;
    }
  };
}

if (!customElements.get('request-quote-form')) {
  customElements.define('request-quote-form', RequestQuoteForm);
}
